import React, { Component } from "react";

import { withUsers } from "../../../shared/containers/containerUsers";
import { withPermissions } from "../../../shared/containers/containerPermissions";
import { withAuth } from "../../../shared/containers/containerAuth";

import Scrollbars from "react-custom-scrollbars-2";
import { states } from "../../../reducers/queriesStates";
import CmsUserPermission from "./CmsUserPermission";

class CmsUserPermissions extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isChangeProcces: false,
      error: null,
    };
  }

  componentDidMount() {
    const { dataState, onGetPermissions } = this.props;

    if (dataState !== states.READY) {
      onGetPermissions({ count: 0 });
    }
  }

  render() {
    const { currentUser, permissions, height = 600, data } = this.props;

    if (permissions === null) {
      return null;
    }

    return (
      <div>  
        <Scrollbars ref="scrollbar" style={{ height: height + "px" }} autoHide={false}>
          {permissions.classificationPermissions.map((classification) => {
            const _permissions = classification.permissions.filter((x) => {
              const userRoleClassification = currentUser.role.classificationPermissions.filter((c) => {
                return c.classPermission === classification.classPermission;
              })[0];

              if (userRoleClassification === undefined) {
                return true;
              }

              return !userRoleClassification.permissions.some((item) => item.id === x.id);
            });

            if (_permissions.length === 0) {
              return null;
            }

            return (
              <div key={classification.classPermission}>
                <strong>{classification.title}</strong>
                <div>
                  {_permissions.map((permission) => {
                    const currentUserClassification = currentUser.classificationPermissions.filter((c) => {
                      return c.classPermission === classification.classPermission;
                    })[0];

                    const checked =
                      currentUserClassification !== undefined &&
                      currentUserClassification.permissions.findIndex((item) => item.id === permission.id) !== -1;

                    return (
                      <CmsUserPermission
                        key={permission.id}
                        permission={permission}
                        checked={checked}
                        classPermission={classification.classPermission}
                      />
                    );
                  })}
                </div>
              </div>
            );
          })}
        </Scrollbars>
      </div>
    );
  }
}

export default withAuth(withPermissions(withUsers(CmsUserPermissions)));
